"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneCGPProgram = exports.asOpIndex = exports.assertOpIndex = exports.asNodeIndex = exports.assertNodeIndex = void 0;
function assertNodeIndex(x) { }
exports.assertNodeIndex = assertNodeIndex;
function asNodeIndex(x) {
    assertNodeIndex(x);
    return x;
}
exports.asNodeIndex = asNodeIndex;
function assertOpIndex(x) { }
exports.assertOpIndex = assertOpIndex;
function asOpIndex(x) {
    assertOpIndex(x);
    return x;
}
exports.asOpIndex = asOpIndex;
function cloneCGPProgram(source) {
    const middleNodes = Array.from({
        length: source.middleNodes.length,
    }, (_, i) => {
        return {
            inputIndexes: [...source.middleNodes[i].inputIndexes],
            operator: source.middleNodes[i].operator,
        };
    });
    const outputs = Array.from({
        length: source.outputs.length,
    }, (_, i) => {
        return source.outputs[i];
    });
    return {
        middleNodes,
        outputs,
    };
}
exports.cloneCGPProgram = cloneCGPProgram;
